//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmptyImg from '@/assets/img/no_search.png'

export default {
  name: 'CEmpty',

  props: {
    imgUrl: {
      type: String,
      default: EmptyImg,
    },

    htmlMsg: { type: String },

    imgWidth: {
      type: [
        Number,
        String,
      ],
      default: '5.62500rem',
    },

    imgHeight: {
      type: [
        Number,
        String,
      ],
      default: 'auto',
    },

    msg: {
      type: String,
      default: '暂无数据',
    },
  },

  data () {
    return {}
  },
}
